import { render, staticRenderFns } from "./DisplayRichTextEditorContents.vue?vue&type=template&id=371f592e&scoped=true"
import script from "./DisplayRichTextEditorContents.vue?vue&type=script&lang=js"
export * from "./DisplayRichTextEditorContents.vue?vue&type=script&lang=js"
import style0 from "./DisplayRichTextEditorContents.vue?vue&type=style&index=0&id=371f592e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371f592e",
  null
  
)

export default component.exports